'use client';

import { type FormControlProps } from '@ironhack/design-system2/components/form-control';
import { FormField } from '@ironhack/design-system2/components/form-field';
import { Input } from '@ironhack/design-system2/components/input';
import { type ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';

type Props = {
  label?: string;
  error?: string;
  name: string;
  placeholder: string;
  isRequired: boolean;
  type?: string;
} & FormControlProps;

export const TextField = (props: Props): ReactElement => {
  const {
    label,
    error,
    name,
    placeholder,
    isRequired,
    type = 'text',
    ...formFieldProps
  } = props;
  const { register } = useFormContext();

  return (
    <FormField
      error={error ?? ''}
      isInvalid={Boolean(error)}
      isRequired={isRequired}
      label={label}
      name={name}
      {...formFieldProps}
    >
      <Input
        placeholder={placeholder}
        type={type}
        {...register(name, { required: isRequired })}
      />
    </FormField>
  );
};
